export const InfoText = ({
  heading,
  description,
}: {
  heading: string
  description
}) => (
  <div className='mb-12 max-sm:mx-auto'>
    <h2 className="mb-2 lg:mb-5 font-['DM_Sans'] whitespace-nowrap font-bold tracking-[0.4px] text-[#001A3D] text-lg md:text-2xl lg:text-4xl">
      {heading}
    </h2>
    <span className='text-sm tracking-[0.4px] text-[#001A3D]'>{description}</span>
  </div>
)
